import React, {useRef, useState} from 'react';
import _ from 'lodash';
import K from '../../k';
import Button from './button';

import Icon from '../icon';
import useClickOutside from '../../hooks/click-outside';

const AddButton = ({disabled, icon, options = [], style, onClick, expandDirection = 'bottom', buttonStyle}) => {
  const buttonRef = useRef(null);
  const hasOptions = options && options.length > 0;
  const [isExpanded, setIsExpanded] = hasOptions ? useState(false) : [false, null];
  const handleClose = () => setIsExpanded?.(false);

  useClickOutside(buttonRef, handleClose);

  const styles = {
    addButtonContainer: {
      position: 'relative',
      display: 'inline-flex',
      flexDirection: expandDirection === 'bottom' ? 'column' : 'column-reverse',
      ...style
    },
    addButton: {
      cursor: 'pointer',
      width: 40,
      height: 40,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'black',
      ...(isExpanded
        ? expandDirection === 'bottom'
          ? {borderRadius: '75px 75px 0 0', borderTop: 'none', borderBottom: '1px solid rgba(255, 255, 255, 0.2)'}
          : {borderRadius: '0 0 75px 75px', borderBottom: 'none', borderTop: '1px solid rgba(255, 255, 255, 0.2)'}
        : {
          borderRadius: '75px',
          borderTop: 'none',
          borderBottom: 'none',
        }),
      ...buttonStyle
    },
    firstChild: expandDirection === 'bottom' ? {borderTopRightRadius: 19} : {borderTopLeftRadius: 19, borderTopRightRadius: 19},
    lastChild: expandDirection === 'bottom' ? {borderBottomLeftRadius: 19, borderBottomRightRadius: 19} : {borderBottomRightRadius: 19},
    addButtonChild: (index) => ({
      position: 'relative',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      backgroundColor: 'black',
      height: 35,
      width: 100,
      color: 'white',
      borderRadius: 0,
      textTransform: 'uppercase',
      ...(index !== options.length - 1 && {borderBottom: '1px solid rgba(255, 255, 255, 0.2)'}),
      ...(index === 0 && styles.firstChild),
      ...(index === options.length - 1 && styles.lastChild)
    }),
    buttonContent: {
      width: '100%',
      height: '100%',
      margin: `0px ${K.spacing}px`,
    },
    addButtonIcon: {
      transform: isExpanded ? 'rotate(45deg)' : 'rotate(0deg)',
      transition: 'transform 0.25s',
      ...K.defaultIconSize
    },
    optionContainer: {
      position: 'absolute',
      top: 40,
      zIndex: 1,
    },
  };

  const handleClick = (e) => {
    if (hasOptions) setIsExpanded?.(!isExpanded);
    else if (onClick) onClick(e);
  };

  const handleOptionClick = (value) => () => {
    if (onClick) onClick(value);

    handleClose();
  };

  return (
    <div ref={buttonRef} style={styles.addButtonContainer}>
      <Button
        {...{disabled}}
        onClick={handleClick}
        icon={<Icon {...{icon}} name='create' theme='white' style={styles.addButtonIcon} />}
        style={styles.addButton}/>
      {isExpanded && (
        <div style={styles.optionContainer}>
          {_.map(options, ({value, manuallyHandleClick, label}, index) => (
            <Button
              key={`add-button-option-${value}`}
              onClick={!manuallyHandleClick ? handleOptionClick(value) : undefined}
              style={styles.addButtonChild(index)}
              contentStyle={styles.buttonContent}
            >{label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

export default AddButton;